import { basicColors, retroColors, electricColors } from "style/basic/basicColors";
export const calenderStyle = {
  calender: {
    default: { background: basicColors.fourth, padding: "15px" },
    retro: { background: "var(--nine)", padding: "0" },
    electric: { background: electricColors.nine, padding: "0" },
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/Calendar/style/Calender.js